import { render, staticRenderFns } from "./BAEventAdminDetailPage.vue?vue&type=template&id=506047d9&"
import script from "./BAEventAdminDetailPage.vue?vue&type=script&lang=ts&"
export * from "./BAEventAdminDetailPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports